export default "<p>\n  authenticate works!\n</p>\n";